var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "activity-card" }, [
    _c("div", { staticClass: "activity-content" }, [
      _c("div", { staticClass: "activity-message" }, [
        _c("strong", [_vm._v(_vm._s(_vm.actorName))]),
        _vm._v(" kullanıcısı\n            "),
        _c("strong", [_vm._v(_vm._s(_vm.visitorName))]),
        _vm._v(" kişisinden\n            "),
        _c("span", { staticClass: "tags" }, [_vm._v(_vm._s(_vm.tagNames))]),
        _vm._v(" etiketlerini kaldırdı.\n        "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "activity-time" }, [
        _vm._v(_vm._s(_vm.formattedTime)),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }